import { render, staticRenderFns } from "./ResortEdit.vue?vue&type=template&id=32f88afa&"
import script from "./ResortEdit.vue?vue&type=script&lang=js&"
export * from "./ResortEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports